import { Container } from './Styles'

const PageContainer = ({ children }) => {
    return <Container>{children}</Container>
}

export default PageContainer
